import { UI, TextTypes, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { IStackProps } from 'native-base';
import React from 'react';

export interface OrderItemProps extends IStackProps {
  label: string;
  value: string | React.ReactNode;
  horizontal?: boolean;
  valueTextProps?: Partial<TextTypes.Props>;
}

export const OrderItem: React.FC<OrderItemProps> = ({
  label,
  value,
  horizontal,
  valueTextProps,
  ...props
}) => {
  const isValueString = typeof value === 'string';

  if (horizontal) {
    return (
      <HStack justifyContent="space-between" space={Spacing['inline.quarck']} {...props}>
        <UI.Text fontSize={Typography['fontsize.xs']}>{label}</UI.Text>
        {isValueString ? (
          <UI.Text {...valueTextProps} maxW={{ base: '200px', sm: 'full' }}>
            {value}
          </UI.Text>
        ) : (
          value
        )}
      </HStack>
    );
  }

  return (
    <VStack space={Spacing['stack.nano']} {...props}>
      <UI.Text fontSize={Typography['fontsize.xs']}>{label}</UI.Text>
      {isValueString ? <UI.Text {...valueTextProps}>{value}</UI.Text> : value}
    </VStack>
  );
};
